import React from 'react';

export const PageSection: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = (props) => {
  const { children, className } = props;
  return (
    <div className="flex flex-row">
      <div className="flex flex-row w-full max-w-[1264px] mx-auto">
        <div className="flex flex-row w-full relative">
          <main
            className={`flex-1 flex flex-col p-4 2xl:p-5 3xl:p-6 pr-6 2xl:pr-7 3xl:pr-8 relative w-full ${className}`}
          >
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};
